import { createFileRoute } from '@tanstack/react-router';

import { PresentationCreate } from '@/module/Author/Presentation/PresentationCreate';

export const Route = createFileRoute('/_auth/author/_author/presentation/_presentation/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <PresentationCreate />;
}
